import React from "react";
import { Helmet } from "react-helmet-async";
import { TranslatedString, useAppConfig } from "@ct-react/core";
import { useLocaleContext, useLocaleUrl } from "@ct-react/locale";
import { allLocales } from "@shared/locales";

export type SeoHelmetProps = {
  title?: string | TranslatedString;
  description?: string | TranslatedString;
  image?: string;
  keywords?: string | string[];
  canonical?: string;
}

const SeoHelmet = (props: SeoHelmetProps) => {

  const { locale } = useLocaleContext();
  const { canonicalBaseUrl: baseUrl } = useAppConfig();
  const { buildLocaleHref } = useLocaleUrl(baseUrl);
  const title = typeof props.title === "string" ? props.title as string : props.title?.value;
  const description = typeof props.description === "string" ? props.description as string : (props.description?.matchLang ? props.description.value : undefined);

  return (
    <Helmet prioritizeSeoTags>
      {!!title && <title>{title}</title>}
      {!!title && <meta property="og:title" content={title} />}
      {!!description && <meta name="description" content={description} />}
      {!!description && <meta property="og:description" content={description} />}
      {!!props.image && <meta property="og:image" content={props.image} />}
      {!!props.keywords && <meta name="keywords" content={Array.isArray(props.keywords) ? props.keywords.join(", ") : props.keywords} />}
      {!!props.canonical && <link rel="canonical" href={buildLocaleHref(props.canonical!)} />}
      {!!props.canonical && allLocales
        .filter(l => l.code !== locale.code)
        .map((l, i) => <link key={i}
                             rel="alternate"
                             hrefLang={l.code}
                             href={buildLocaleHref(props.canonical!, l)}/>)}
    </Helmet>);

}

export default SeoHelmet;
